<template>
    <Modal
        ref="modalRef"
        :name="name"
        :primary-button-disabled="!canConfirm"
        :primary-button-label="primaryButtonLabel"
        :processing="processing"
        max-width="lg"
        :title="trans('subscription.notifications.confirm_title')"
        @submit="$emit('confirm')"
    >
        <p v-if="changes.length === 0" class="text-gray-500">{{ trans('subscription.notifications.confirm_empty') }}</p>
        <ul v-else class="mb-0 list-none p-0">
            <li v-for="change in changes" :key="`${change.notification_type}::${change.subscriber_key}::${change.channel}`" class="mb-2">
                <strong>{{ change.subscriber_label }}:</strong>
                <span class="ms-1">
                    <span :class="change.enabled ? 'text-green-600' : 'text-red-600'">{{
                        change.enabled ? trans('subscription.notifications.action_enable') : trans('subscription.notifications.action_disable')
                    }}</span>
                    {{
                        trans('subscription.notifications.confirm_change_target', {
                            channel: change.channel_label,
                            notification: change.notification_label,
                        })
                    }}
                </span>
            </li>
        </ul>
    </Modal>
</template>

<script setup>
import { computed, ref } from 'vue';
import { trans } from '@/mixins/i18n';
import Modal from '@/Components/Modal.vue';

const props = defineProps({
    name: { type: String, default: 'confirm-notification-changes' },
    changes: { type: Array, default: () => [] },
    processing: { type: Boolean, default: false },
});

defineEmits(['confirm']);

const modalRef = ref(null);

const canConfirm = computed(() => props.changes.length > 0);
const primaryButtonLabel = computed(() => trans('subscription.notifications.confirm_apply', { count: props.changes.length }));

defineExpose({
    close: () => modalRef.value?.close(),
});
</script>
